<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <div class="horizontal-menu">
        <div class="horizontal-menu-item">基本设置</div>
      </div>

      <div class="right-menu">
        <el-dropdown class="avatar-container right-menu-item" trigger="click">
          <div class="avatar-wrapper">
            <img class="user-avatar" :src="avatar" />
            <i class="el-icon-caret-bottom"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <router-link to="/">
              <el-dropdown-item>首页</el-dropdown-item>
            </router-link>
            <el-dropdown-item divided>
              <span @click="showChangePassword" style="display: block">修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <span @click="logout" style="display: block">注销</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-menu>

    <div class="page-breadcrumb">
      <div class="page-breadcrumb__content">
        <div
          v-for="(item, index) in breadcrumbList"
          :key="index"
          class="page-breadcrumb__content-wrapper"
        >
          <span class="content-title">{{ item.meta.title }}</span>
          <span v-if="index !== breadcrumbList.length - 1" class="content-split">/</span>
        </div>
      </div>
    </div>

    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="400px">
      <el-form
        :rules="rules"
        ref="dataForm"
        :model="temp"
        class="post-main-container post-dialog-container"
      >
        <el-form-item label="旧密码：" prop="oldPwd">
          <el-input v-model="temp.oldPwd" type="password" />
        </el-form-item>

        <el-form-item label="新密码：" prop="newPwd">
          <el-input v-model="temp.newPwd" type="password" />
        </el-form-item>

        <el-form-item label="确认密码：" prop="rePwd">
          <el-input v-model="temp.rePwd" type="password" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="changePassword" :loading="btnLoading" type="primary">提交</el-button>
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { changePassword } from '@/api/auth'
import avatar from '@/assets/avatar.jpg'

export default {
  data() {
    return {
      avatar,

      dialogVisible: false,
      btnLoading: false,
      temp: {
        oldPwd: '',
        newPwd: '',
        rePwd: ''
      },
      rules: {
        oldPwd: [{ required: true, message: ' ', trigger: 'blur' }],
        newPwd: [{ required: true, message: ' ', trigger: 'blur' }],
        rePwd: [{ required: true, message: ' ', trigger: 'blur' }]
      },

      breadcrumbList: []
    }
  },

  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },

  created() {
    this.getBreadcrumb()
  },

  methods: {
    showChangePassword() {
      this.dialogVisible = true
    },

    changePassword() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.btnLoading = true
          changePassword(this.temp)
            .then(() => {
              this.btnLoading = false
              this.dialogVisible = false
              this.$message.success('修改密码成功')
            })
            .catch(() => {
              this.btnLoading = false
            })
        }
      })
    },

    logout() {
      this.$store.dispatch('logout').then(() => window.location.reload())
    },

    getBreadcrumb() {
      const matched = this.$route.matched.filter((item) => item.meta && item.meta.title)

      this.breadcrumbList = matched.filter(
        (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
      )
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 190px;
  z-index: 100;
  height: 64px;
  border-bottom: 1px solid #f3f3f3 !important;

  .horizontal-menu {
    display: flex;
    float: left;
    margin-left: 30px;

    .horizontal-menu-item {
      margin: 0 15px;
      height: 64px;
      line-height: 64px;
      border-bottom: 3px solid var(--color-primary) !important;
      color: #263e6a;
      cursor: pointer;
    }
  }

  .right-menu {
    float: right;
    height: 100%;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }

    .international {
      vertical-align: top;
    }

    .avatar-container {
      display: flex;
      align-items: center;
      margin-right: 30px;
      height: 100%;

      .avatar-wrapper {
        cursor: pointer;
        position: relative;

        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          position: absolute;
          top: 25px;
          right: -20px;
          font-size: 12px;
        }
      }
    }
  }
}

.page-breadcrumb {
  margin-top: 64px;
  padding: 30px 25px;

  .page-breadcrumb__content {
    display: flex;

    .page-breadcrumb__content-wrapper {
      .content-title,
      .content-split {
        font-size: 20px;
        font-weight: bold;
        color: #112955;
        opacity: 0.6;
      }

      .content-split {
        margin: 0 12px;
      }

      &:last-child {
        .content-title,
        .content-split {
          opacity: 1;
        }
      }
    }
  }
}
</style>
